/*
 * @Description: 按需引入vant组件
 * @version: 版本 3.4
 * @Author: 作者 chuzhangyi
 * @Date: 2020-07-27 11:47:16
 * @LastEditTime: 2024-09-13 14:19:58
 */

import Vue from 'vue';
import '@vant/touch-emulator';
// 引入全部样式
import {
  Button,
  Icon,
  Loading,
  List,
  Popup,
  Toast,
  Dialog,
  PullRefresh,
  Overlay,
  Tab,
  Tabs,
  Col,
  Row,
  Sticky,
  Picker,
  Form,
  Field,
  Empty,
  Swipe, SwipeItem,
  DatetimePicker,
  Search,
  NavBar,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Stepper,
  Step,
  Steps,
  Switch,
  Cell,
  CellGroup,
  Tag,
  Popover,
  Area,
  Collapse, CollapseItem,
  NoticeBar,
  ImagePreview,
  Image as VanImage,
  DropdownMenu, DropdownItem,
  Calendar,
  SwipeCell,
  Divider,
  Uploader,
  ActionSheet,
  CountDown,
  Sidebar, 
  SidebarItem,
  Badge,
  Pagination,
  Tabbar,
  TabbarItem,
} from 'vant';

Vue.use(Button)
  .use(Badge)
  .use(Uploader)
  .use(ActionSheet)
  .use(Icon)
  .use(Loading)
  .use(List)
  .use(Popup)
  .use(Toast)
  .use(Dialog)
  .use(PullRefresh)
  .use(Overlay)
  .use(Tab)
  .use(Tabs)
  .use(Col)
  .use(Row)
  .use(Sticky)
  .use(Picker)
  .use(Form)
  .use(Field)
  .use(Empty)
  .use(Swipe)
  .use(SwipeItem)
  .use(DatetimePicker)
  .use(Search)
  .use(NavBar)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Stepper)
  .use(Step)
  .use(Steps)
  .use(Switch)
  .use(Cell)
  .use(CellGroup)
  .use(Tag)
  .use(Popover)
  .use(Area)
  .use(Collapse)
  .use(CollapseItem)
  .use(NoticeBar)
  .use(ImagePreview)
  .use(VanImage)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Calendar)
  .use(SwipeCell)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Divider)
  .use(CountDown)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Pagination)
  .use(Tabbar)
  .use(TabbarItem)
